import React, {useEffect, useState} from "react";
import {Icon, Input, Menu, MenuItem, MenuMenu, SemanticCOLORS, SemanticICONS} from "semantic-ui-react";

export interface AppListMenuButton {
    key: string,
    name?: string,
    icon?: SemanticICONS,
    iconColor?: SemanticCOLORS,
    alignRight?: boolean,
    hidden?: boolean
}

export const defaultButtons = [
    {
        key: "view",
        name: "Просмотр",
        icon: "zoom",
        iconColor: "blue"
    } as AppListMenuButton,
    {
        key: "add",
        name: "Добавить",
        icon: "plus",
        iconColor: "green"
    } as AppListMenuButton,
    {
        key: "edit",
        name: "Изменить",
        icon: "edit",
        iconColor: "orange"
    } as AppListMenuButton,
    {
        key: "delete",
        name: "Удалить",
        icon: "delete",
        iconColor: "red"
    } as AppListMenuButton,
    {
        key: "refresh",
        icon: "refresh",
        iconColor: "violet",
        alignRight: true
    } as AppListMenuButton
]

interface Props<TItem> {
    buttons?: AppListMenuButton[];
    disabledButtons?: string[];
    onButtonClick?: (key: string) => {};
    showSearchInput?: boolean;
    onSearchInputChanged?: (value?: string) => void;
}

const AppListMenu = function <TItem>(props: Props<TItem>) {
    const buttons = props.buttons ?? defaultButtons;
    const disabledButtons = props.disabledButtons ?? [];
    const [searchInput, setSearchInput] = useState<string>("");

    useEffect(() => {
        if (props.onSearchInputChanged)
            props.onSearchInputChanged!(searchInput);
    }, [searchInput]);

    const showSearchInput = props.showSearchInput ?? true;

    return <>
        <Menu pointing style={{marginBottom: "0px", backgroundColor: "#f6f6f6"}} attached={"top"} stackable>
            {buttons
                .filter((x) => !x.hidden)
                .filter((x) => !x.alignRight).map((button) =>
                <MenuItem key={button.key}
                          link disabled={disabledButtons.find((x) => x == button.key) != undefined}
                          onClick={props.onButtonClick ? () => props.onButtonClick!(button.key) : undefined}>
                    {button.icon &&
                        <><Icon name={button.icon} color={button.iconColor}/>&nbsp;</>}
                    {button.name}
                </MenuItem>
            )}
            <MenuMenu position='right'>

                {buttons
                    .filter((x) => !x.hidden)
                    .filter((x) => x.alignRight).map((button) =>
                    <MenuItem
                        key={button.key}
                        link disabled={disabledButtons.find((x) => x == button.key) != undefined}
                        onClick={props.onButtonClick ? () => props.onButtonClick!(button.key) : undefined}>
                        {button.icon &&
                            <><Icon name={button.icon} color={button.iconColor}/>&nbsp;</>}
                        {button.name}
                    </MenuItem>
                )}

                {showSearchInput &&
                    <MenuItem position={"right"}>
                        <Input value={searchInput} icon={
                            <>
                                {searchInput ? (
                                    <Icon
                                        name="delete"
                                        link
                                        onClick={() => {
                                            setSearchInput("");
                                        }}
                                        style={{marginRight: "1.5rem"}}
                                    />
                                ) : null}
                                <Icon name="search" color="grey"/>
                            </>
                        } placeholder={'Поиск... '} onChange={(e, d) => setSearchInput(d.value)}/>
                    </MenuItem>}
            </MenuMenu>
        </Menu></>;
}

export default AppListMenu;